/**
 *! Don't change this file, the values here 
 *! correspond with those returned by NopCommerce.
 */

const productTypeFlags = Object.freeze({
    groupedProduct: 10,
    simpleProduct: 5,
})

const productTypes = Object.freeze({
    Simple: 'SimpleProduct',
    Grouped: 'GroupedProduct',
})

export { productTypeFlags, productTypes }
